/*
  Product recommendations (related and complementary products): an empty element that asks Shopify's recommendations
  endpoint for its section once it comes near the screen (whenNear, assets/global.js), and shows what comes back. A
  failed or empty answer leaves it empty (it stays in the page, so nothing shifts); a request that takes the full
  request time (REQUEST_TIMEOUT in assets/constants.js) counts as failed. Leaving the page cancels the request.
*/

if (!customElements.get('product-recommendations')) {
  const answers = sectionAnswers({ size: 0 });

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.stopWaiting = whenNear(this, (signal) => this.load(signal));
    }

    disconnectedCallback() {
      this.stopWaiting?.();
    }

    async load(signal) {
      const { url, productId, sectionId } = this.dataset;
      const page = await answers.page(`${url}&product_id=${productId}&section_id=${sectionId}`, signal);
      const recommendations = page.querySelector('product-recommendations');

      if (recommendations?.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        this.classList.add('product-recommendations--loaded');
      }

      // A complementary block with no products takes no room; in the theme editor it stays, with its note, so it
      // can be selected.
      if (
        !this.querySelector('slide-rotator') &&
        this.classList.contains('complementary-products') &&
        !window.Shopify?.designMode
      ) {
        this.remove();
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
